import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './routerPromptStyles.module.scss';
import classnames from 'classnames';
interface IRouterPromptWrapperProps {
  children: React.ReactNode;
  className?: string;
  closeModal?: () => void;
}

const RouterPromptWrapper = ({
  children,
  className,
  closeModal,
}: IRouterPromptWrapperProps) => {
  const elementRef = useRef<HTMLDivElement | null>(null);

  if (!elementRef.current) {
    const div = document.createElement('div');
    elementRef.current = div;
  }

  const onClickHandler = async (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && closeModal) {
      closeModal();
    }
  };

  useEffect(() => {
    const modalRoot = document.getElementById('app');

    if (modalRoot && elementRef.current) {
      modalRoot.appendChild(elementRef.current);
      return () => {
        if (elementRef.current) {
          modalRoot.removeChild(elementRef.current);
        }
      };
    }
  }, []);

  return createPortal(
    <div
      className={classnames(styles.modalWrapper, className)}
      onClick={onClickHandler}
    >
      {children}
    </div>,
    elementRef.current,
  );
};

export default RouterPromptWrapper;
